import React from "react";
import Projects from "./Projects";

import bloodbank from "../../Images/projects/bloodbank.png";
import macbook from "../../Images/projects/macbook.png";
import pottery from "../../Images/projects/pottery.png";
import learning from "../../Images/projects/programming.png";
import sigmacare from "../../Images/projects/sigmacare.png";
import travels from "../../Images/projects/travels.png";

const ProjectData = () => {
  const projects = [
    {
      id: 1,
      name: "SigmaCare Hospital",
      img: sigmacare,
      des: "It is a Hospital Management website. Here patient can find their best services and best output from our doctors and staff.",
    },
    {
      id: 2,
      name: "Blood Bank Website",
      img: bloodbank,
      des: "It is a Blood Bank website. Here donar can donet blood and anyone can take blood as blood-group quantity or request for blood if anyone needed.",
    },
    {
      id: 3,
      name: "Travel Agency Website",
      img: travels,
      des: "It is a Travels Agency website. Where travellers can share their experiences. If anyone want's to travel they can book their services.",
    },
    {
      id: 4,
      name: "Pottery Shop Website",
      img: pottery,
      des: "It is a Pottery Shop website. Where anyone can buy their favourite pottery. For buying best pottery products they can use stripe payment method ",
    },
    {
      id: 5,
      name: "Programming Channel",
      img: learning,
      des: "This website is a collection of best programming youtube channel. Here anyone can learn programming from Youtube Channel.",
    },
    {
      id: 6,
      name: "Buy MackBook Pro",
      img: macbook,
      des: "It is a Buy Macbook Pro website. Where anyone can chose Macbook with configuration as they want.",
    },
  ];
  return (
    <div className="container mt-4 pb-5 mb-2">
      <h1 className="text-center pt-3 blogs-section">Some Recent Projects !</h1>
      <div className="row d-flex justify-content-center align-items-center">
        {projects.map((project) => (
          <Projects project={project}></Projects>
        ))}
      </div>
    </div>
  );
};

export default ProjectData;
